export const POST_LOGIN_API_REQUEST = "POST_LOGIN_API_REQUEST";
export const POST_LOGIN_API_SUCCESS = "POST_LOGIN_API_SUCCESS";
export const POST_LOGIN_API_ERROR = "POST_LOGIN_API_ERROR";

export const SECURITY_IS_LOGGED_IN = "SECURITY_IS_LOGGED_IN"

export const POST_USERDATA_API_REQUEST = "POST_USERDATA_API_REQUEST";
export const POST_USERDATA_API_SUCCESS = "POST_USERDATA_API_SUCCESS";
export const POST_USERDATA_API_ERROR = "POST_USERDATA_API_ERROR";

export const GET_PLATFORM_SECURITY_API_REQUEST = "GET_PLATFORM_SECURITY_API_REQUEST";
export const GET_PLATFORM_SECURITY_API_SUCCESS = "GET_PLATFORM_SECURITY_API_SUCCESS";
export const GET_PLATFORM_SECURITY_API_ERROR = "GET_PLATFORM_SECURITY_API_ERROR";

export const BLUR_APP = "BLUR_APP";